module.exports = __webpack_public_path__ + "static/media/list.dfa5700b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/list.svg
// module id = 574
// module chunks = 0